namespace TabAurous.OMS {
    export interface HsnTaxMasterRow {
        Code?: string;
        Type?: string;
        Description?: string;
        TaxGroup?: number;
        TaxId?: number;
        TaxLedgerId?: number;
        Tax1Id?: number;
        Tax1LedgerId?: number;
        Tax2Id?: number;
        Tax2LedgerId?: number;
        Details?: HSNTaxDetailsRow[];
        CessId?: number;
        CessLedgerId?: number;
        Cess1Id?: number;
        Cess1LedgerId?: number;
        Cess2Id?: number;
        Cess2LedgerId?: number;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        SysDate?: string;
    }

    export namespace HsnTaxMasterRow {
        export const idProperty = 'Code';
        export const nameProperty = 'Code';
        export const localTextPrefix = 'OMS.HsnTaxMaster';
        export const lookupKey = 'OMS.HsnTaxMaster';

        export function getLookup(): Q.Lookup<HsnTaxMasterRow> {
            return Q.getLookup<HsnTaxMasterRow>('OMS.HsnTaxMaster');
        }
        export const deletePermission = 'Masters:HSN:Delete';
        export const insertPermission = 'Masters:HSN:Add';
        export const readPermission = '*';
        export const updatePermission = 'Masters:HSN:Edit';

        export declare const enum Fields {
            Code = "Code",
            Type = "Type",
            Description = "Description",
            TaxGroup = "TaxGroup",
            TaxId = "TaxId",
            TaxLedgerId = "TaxLedgerId",
            Tax1Id = "Tax1Id",
            Tax1LedgerId = "Tax1LedgerId",
            Tax2Id = "Tax2Id",
            Tax2LedgerId = "Tax2LedgerId",
            Details = "Details",
            CessId = "CessId",
            CessLedgerId = "CessLedgerId",
            Cess1Id = "Cess1Id",
            Cess1LedgerId = "Cess1LedgerId",
            Cess2Id = "Cess2Id",
            Cess2LedgerId = "Cess2LedgerId",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            SysDate = "SysDate"
        }
    }
}
